var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React, { memo } from 'react';
import { Paper, useTheme, makeStyles, Typography, Table, TableRow, TableBody, TableCell, TableContainer } from '@material-ui/core';
import { defaultVegaTooltipOptions } from '../MuiVegaTheme';
import { stringify } from './stringify';
var useStyles = makeStyles(function (theme) { return ({
    root: {
        visibility: 'hidden',
        padding: theme.spacing(1),
        position: 'absolute',
        zIndex: theme.zIndex.tooltip,
        pointerEvents: 'none'
    },
    visible: {
        visibility: 'visible'
    },
    tableCell: {
        borderBottom: 'none'
    }
}); }, { name: 'MuiVegaTooltip' });
var MuiVegaTooltipContent = function (props) {
    var _a, _b;
    var classes = props.classes, value = props.value;
    var theme = useTheme();
    var maxDepth = (_b = (_a = theme.vegaTooltip) === null || _a === void 0 ? void 0 : _a.maxDepth) !== null && _b !== void 0 ? _b : defaultVegaTooltipOptions.maxDepth;
    if (Array.isArray(value)) {
        return (React.createElement(React.Fragment, null, "[" + value
            .map(function (v) { return (typeof v === 'string' ? v : stringify(v, maxDepth)); })
            .join(', ') + "]"));
    }
    if (typeof value === 'object' && value !== null) {
        var titleElement = void 0;
        var tableElement = void 0;
        var _c = value, title = _c.title, rest_1 = __rest(_c, ["title"]);
        if (title) {
            titleElement = (React.createElement(Typography, { key: "title", component: "h2", variant: "h5" }, String(title)));
        }
        var keys = Object.keys(rest_1);
        if (keys.length > 0) {
            tableElement = (React.createElement(TableContainer, null,
                React.createElement(Table, { size: "small" },
                    React.createElement(TableBody, null, keys.map(function (key) {
                        var val = rest_1[key];
                        if (val === undefined)
                            return undefined;
                        if (typeof val === 'object' && val !== null) {
                            val = stringify(val, maxDepth);
                        }
                        return (React.createElement(TableRow, { key: key },
                            React.createElement(TableCell, { variant: "head", align: "right", className: classes.tableCell }, key),
                            React.createElement(TableCell, { className: classes.tableCell }, String(val))));
                    })))));
        }
        return (React.createElement(React.Fragment, null,
            titleElement,
            tableElement));
    }
    return React.createElement(React.Fragment, null, String(value));
};
/**
 * Vega Tooltip using Material-UI's <Paper>
 */
export var MuiVegaTooltip = function (props) {
    var _a, _b;
    var x = (_a = props.position, _b = _a === void 0 ? { x: 0, y: 0 } : _a, _b.x), y = _b.y, value = props.value;
    var classes = useStyles(props);
    return (React.createElement(Paper, { className: clsx(classes.root, value !== null && classes.visible), style: {
            left: x,
            top: y
        } },
        React.createElement(MuiVegaTooltipContent, { classes: classes, value: value })));
};
MuiVegaTooltip = memo(MuiVegaTooltip);
